import { render, staticRenderFns } from "./CompensationsManager.vue?vue&type=template&id=40d92b0d"
import script from "./CompensationsManager.vue?vue&type=script&lang=js"
export * from "./CompensationsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports